import React, { Component } from "react"
import { Card, CardBody, Col, Row } from "reactstrap";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import NumberFormat from "../../../components/NumberFormat";
import slugify from 'react-slugify';
import { Button } from "react-bootstrap";

class UICardViewNoImage extends Component {
    constructor(props) {
        super(props)
        this.state = {}

    }

    render() {

        return (
            <Col sm={12} lg={6} xl={6} className=" mb-1">
                <a id={slugify((this.props.nameGroup.concat(" ").concat(this.props.prod.name)).toLowerCase())}
                    name={slugify((this.props.nameGroup.concat(" ").concat(this.props.prod.name)).toLowerCase())}
                    onClick={() => {
                        window.dataLayer.push({ event: slugify((this.props.nameGroup.concat(" ").concat(this.props.prod.name)).toLowerCase()) });
                        this.props.toggleproductsmodal()
                        this.props.getParamsModal(
                            {
                                price: this.props.prod.price,
                                id: this.props.prod.id,
                                titleName: this.props.prod.name,
                                description: this.props.desc,
                                type: this.props.type,
                                prod_type: this.props.prod.type,
                                nameGroup: this.props.nameGroup,
                                idGroup: this.props.idGroup,
                                title: this.props.prod.type === 1 ? this.props.prod.name.concat(' SABORES ').concat(' ( ').concat(this.props.prod.qtd_pieces).concat(' PEDAÇOS )') : this.props.prod.name.concat(' ( ').concat(this.props.prod.qtd_pieces).concat(' PEDAÇOS )'),
                                size: {
                                    id: this.props.prod.id,
                                    price: this.props.prod.price
                                }
                            })
                    }}>
                    <div className="bg-white border border-1  rounded-2 p-3">
                        <CardBody>
                            <h2 className="font-got-lt-13-300h text-start fw-bold">{this.props.prod.name.toUpperCase()} {this.props.prod.type === 1 ? 'SABORES' : ''} ( {this.props.prod.qtd_pieces} PEDAÇOS)</h2>
                            <h2 className="font-bl-11-400h text-end mt-4">A partir <b className="fw-bold">{<NumberFormat value={this.props.prod.price} />}</b></h2>
                            <div className="text-start">
                                <Button
                                    onClick={(e) => {
                                        window.dataLayer.push({ event: slugify((this.props.nameGroup.concat(" ").concat(this.props.prod.name)).toLowerCase()) });
                                        this.props.toggleproductsmodal()
                                        this.props.getParamsModal(
                                            {
                                                price: this.props.prod.price,
                                                id: this.props.prod.id,
                                                titleName: this.props.prod.name,
                                                description: this.props.desc,
                                                type: this.props.type,
                                                prod_type: this.props.prod.type,
                                                nameGroup: this.props.nameGroup,
                                                idGroup: this.props.idGroup,
                                                title: this.props.prod.type === 1 ? this.props.prod.name.concat(' SABORES ').concat(' ( ').concat(this.props.prod.qtd_pieces).concat(' PEDAÇOS )') : this.props.prod.name.concat(' ( ').concat(this.props.prod.qtd_pieces).concat(' PEDAÇOS )'),
                                                size: {
                                                    id: this.props.prod.id,
                                                    price: this.props.prod.price
                                                }
                                            })
                                    }}
                                    className={' btn  btn-animated font-got-lt-14-400h   text-center'} variant="outline-danger" size="sm">
                                    Personalizar
                                </Button>
                            </div>
                        </CardBody>
                    </div>
                </a>
            </Col>
        )
    }
}

UICardViewNoImage.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
    refresh: PropTypes.any,
    type: PropTypes.any,
    loading: PropTypes.any,
    prod: PropTypes.any,
    desc: PropTypes.any,
    idGroup: PropTypes.any,
    nameGroup: PropTypes.any,
    toggleproductsmodal: PropTypes.func,
    getParamsModal: PropTypes.func,


}
const mapStateToProps = state => {
    return {}
}
export default withTranslation()(withRouter(connect(mapStateToProps, {


})(
    (UICardViewNoImage)
)))
